import service from '../service.js'

export default{

    createDependent(fname, lname, mname, aname, birthdate, contact_no, relation, employee_key){
        return service.post('dependent',{
            fname       : fname,
            lname       : lname,
            mname       : mname,
            aname       : aname,
            birthdate   : birthdate,
            contact_no  : contact_no,
            relation    : relation,
            employee_key: employee_key
        })
    },
}